import { Validator } from '@vista-digital/validator';
import { FilmThumbnailMediaType } from '../../../film/thumbnail/types/media-type';
/**
 * Default configuration options for the Showtime Summary Component.
 */
export const defaultShowtimeSummaryConfig = {
    filmThumbnail: {
        show: true,
        mediaType: FilmThumbnailMediaType.Poster
    },
    showOrderTotal: true,
    showSeatsSummary: true,
    showFilmBackdrop: false,
    attributeLegend: {
        show: true,
        showLabel: false
    }
};
export const showtimeSummaryFilmThumbnailValidator = Validator.object({
    show: Validator.boolean(),
    mediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType))
});
export const showtimeSummaryAttributeLegendValidator = Validator.object({
    show: Validator.boolean(),
    showLabel: Validator.optional(Validator.boolean()),
    attributeFilterFn: Validator.optional(Validator.fn())
});
export const showtimeSummaryConfigValidator = Validator.object({
    filmThumbnail: showtimeSummaryFilmThumbnailValidator,
    showOrderTotal: Validator.boolean(),
    showSeatsSummary: Validator.boolean(),
    showFilmBackdrop: Validator.boolean(),
    attributeLegend: showtimeSummaryAttributeLegendValidator
});
